import type {PublicMethodUtils} from '@wix/document-services-types'
import type {BranchesPublicAPI} from '@wix/document-services-public-types'
import type {PublicModuleDeclaration} from '../../documentServicesInitialisation'

export default function (publicMethodUtils: PublicMethodUtils): PublicModuleDeclaration<BranchesPublicAPI> {
    const {
        extensionPublicAPI: {immediate}
    } = publicMethodUtils
    return {
        methods: {
            branches: {
                getPublishedBranchId: immediate('branches.getPublishedBranchId'),
                getBranchById: immediate('branches.getBranchById'),
                getBranchRevision: immediate('branches.getBranchRevision'),
                getAllBranches: immediate('branches.getAllBranches'),
                getUserAndMobileBranches: immediate('branches.getUserAndMobileBranches'),
                getUserBranches: immediate('branches.getUserBranches'),
                createUserBranchFromSiteBranch: immediate('branches.createUserBranchFromSiteBranch'),
                createUserBranchFromTemplate: immediate('branches.createUserBranchFromTemplate'),
                deleteUserBranch: immediate('branches.deleteUserBranch'),
                updateBranchName: immediate('branches.updateBranchName'),
                getBranchAppsState: immediate('branches.getBranchAppsState'),
                getAppBranches: immediate('branches.getAppBranches')
            }
        }
    }
}
